<div class="row">
  <div class="col-auto align-self-center">
    <h2>{{ title | titlecase }}</h2>
  </div>
</div>
<lds-card padding="md">
  <div class="row">
    <div class="col">
      <ng-content select="[table-filter]"></ng-content>
    </div>
  </div>
  <div class="row mb-3">
    <div class="col-6 col-md-4 col-lg-3"></div>
    <div class="col button-col">
      <lds-button
        iconBefore="download"
        variation="outline"
        appearance="primary"
        (onClick)="download()"
        *ngIf="!downloading"
        >Download</lds-button
      >
      <lds-button
        iconBefore="download"
        variation="outline"
        appearance="primary"
        [isDisabled]="true"
        *ngIf="downloading"
        >Downloading...</lds-button
      >
    </div>
  </div>
  <div class="row mb-3">
    <div class="col">
      <ng-content select="[table-definition]"></ng-content>
    </div>
  </div>
</lds-card>
